// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header___2iaHA","close-button":"Header__close-button___24gXc"};